var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbrDarf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui ui-ubr_darf",
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.072 4h-44c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h44c3.3 0 6-2.7 6-6V10c0-3.3-2.7-6-6-6zm2 66c0 1.1-.9 2-2 2h-44c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h44c1.1 0 2 .9 2 2v60z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.972 36h-39.8v4h39.8v-4zm0 12.1h-39.8v4h39.8v-4zm0 12h-39.8v4h39.8v-4zm-.1-42.3h-19.8v4h19.8v-4zm-33.8 10.1h4.1c3.3 0 6-2.7 6-6v-4.2c0-3.3-2.7-6-6-6h-4.1c-3.3 0-6 2.7-6 6v4.2c0 3.3 2.7 6 6 6zm-2-10.2c0-1.1.9-2 2-2h4.1c1.1 0 2 .9 2 2v4.2c0 1.1-.9 2-2 2h-4.1c-1.1 0-2-.9-2-2v-4.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrDarf);
export default __webpack_public_path__ + "static/media/ubr_darf.90afff831a269c608cdf770c64d2cc54.svg";
export { ForwardRef as ReactComponent };